import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useAtom } from 'jotai';
import { useEffect } from 'react';

import type { LimaSourceEventsPerDayDTO } from '@/features/DevicesTable/DevicesTable.types';
import useHandleError from '@/hooks/useHandleError';
import { useDeviceSelectionParams } from '@/pages/Administration/Devices/Devices.hooks';

import { limaSourceEventsPerDayAtom } from './LimaSourceTrendChart.store';

const useFetchLimaSourceEventsPerDay = () => {
  const { sourceUid } = useDeviceSelectionParams();
  const [, setLimaSourceEvents] = useAtom(limaSourceEventsPerDayAtom);
  const handleError = useHandleError();
  const { data, isSuccess, isError, error, isFetching } = useQuery<
    LimaSourceEventsPerDayDTO[],
    AxiosError
  >({
    queryKey: [`lima_sources/${sourceUid}/lima_source_events/per_day`]
  });

  useEffect(() => {
    if (isSuccess) {
      setLimaSourceEvents(data || []);
    }
    if (isError) {
      setLimaSourceEvents([]);
      handleError(error, 'Failure to fetch events data.');
    }
  }, [isSuccess, isError, data]);

  return {
    isFetching
  };
};
export default useFetchLimaSourceEventsPerDay;
